import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _ArrowDropUp(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", d: "m12.192 9.23 3.714 4.458A.8.8 0 0 1 15.292 15H8.708a.8.8 0 0 1-.615-1.312l3.715-4.458a.25.25 0 0 1 .384 0" }) }) });
}
const ArrowDropUp = forwardRef(_ArrowDropUp);
export { ArrowDropUp };
